/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { mapValues } from '../runtime';
import { FxIdWebModelsTagLinkViewFromJSON, FxIdWebModelsTagLinkViewToJSON, } from './FxIdWebModelsTagLinkView';
import { FxIdApplicationTagsProvidersSurveyDataFromJSON, FxIdApplicationTagsProvidersSurveyDataToJSON, } from './FxIdApplicationTagsProvidersSurveyData';
/**
 * Check if a given object implements the FxIdWebFeaturesProfileGetResponseConnectedGame interface.
 */
export function instanceOfFxIdWebFeaturesProfileGetResponseConnectedGame(value) {
    if (!('Game' in value) || value['Game'] === undefined)
        return false;
    if (!('GameJwt' in value) || value['GameJwt'] === undefined)
        return false;
    if (!('GameUid' in value) || value['GameUid'] === undefined)
        return false;
    if (!('StoreEnabled' in value) || value['StoreEnabled'] === undefined)
        return false;
    if (!('TagsLinks' in value) || value['TagsLinks'] === undefined)
        return false;
    if (!('Surveys' in value) || value['Surveys'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesProfileGetResponseConnectedGameFromJSON(json) {
    return FxIdWebFeaturesProfileGetResponseConnectedGameFromJSONTyped(json, false);
}
export function FxIdWebFeaturesProfileGetResponseConnectedGameFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Game': json['Game'],
        'GameJwt': json['GameJwt'],
        'GameUid': json['GameUid'],
        'StoreEnabled': json['StoreEnabled'],
        'TagsLinks': (json['TagsLinks'].map(FxIdWebModelsTagLinkViewFromJSON)),
        'Surveys': (mapValues(json['Surveys'], FxIdApplicationTagsProvidersSurveyDataFromJSON)),
    };
}
export function FxIdWebFeaturesProfileGetResponseConnectedGameToJSON(json) {
    return FxIdWebFeaturesProfileGetResponseConnectedGameToJSONTyped(json, false);
}
export function FxIdWebFeaturesProfileGetResponseConnectedGameToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Game': value['Game'],
        'GameJwt': value['GameJwt'],
        'GameUid': value['GameUid'],
        'StoreEnabled': value['StoreEnabled'],
        'TagsLinks': (value['TagsLinks'].map(FxIdWebModelsTagLinkViewToJSON)),
        'Surveys': (mapValues(value['Surveys'], FxIdApplicationTagsProvidersSurveyDataToJSON)),
    };
}
//# sourceMappingURL=FxIdWebFeaturesProfileGetResponseConnectedGame.js.map